// Hamburger nav 
(function() {
	const button = document.getElementById('primary-nav-toggle');
	if(! button ) {
		return;
	}
	
	const hamb = button.querySelector('.hamburger');
	const panel = document.querySelector('.primary-nav-mobile-panel');
	
	button.addEventListener('click', event => {
		const expanded = panel.getAttribute('aria-expanded') !== false;
		document.body.classList.toggle('nav-shown');
		hamb.classList.toggle('is-active');
		event.currentTarget.setAttribute('aria-expanded', ! expanded);
		panel.setAttribute('aria-expanded', ! expanded);
	});
}());